import { useAuthAppStore } from "@/store/stores/authStore";

export class ProcurementService {
  // async getAllEntitiesPaged({ procurementServiceClient, params }) {
    
  //   params.filter = JSON.stringify([
  //     "PurchaseRequestNumber", "=", params.prNumber,
  //   ]);

  //   var response = await procurementServiceClient.get({
  //     route: "/approval-matrix-step/get-all-entities-paged",
  //     params: params,
  //     //data: { Numbers: ["126"] },
  //     //data: JSON.stringify({"Numbers": "['126']"}),

  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {
  //       console.log("resp", resp);
  //     },
  //   });

  //   return response;
  // }

  // async getEntityByPkey({ procurementServiceClient, params }) {
  //   var response = await procurementServiceClient.get({
  //     route: "/approval-matrix-step/get-entity-by-pkey",
  //     params: params,
  //     //data: { Numbers: ["126"] },
  //     //data: JSON.stringify({"Numbers": "['126']"}),
  //     // JSON.stringify(["Number", "contains", searchQuery]);
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {
  //       console.log("resp", resp);
  //     },
  //   });

  //   return response;
  // }

  // async getFindByPurchaseRequestNumber({ procurementServiceClient, params }) {
  //   var response = await procurementServiceClient.get({
  //     route: "/approval-matrix-step/find-by-purchase-request-number",
  //     params: params,
  //     //data: { Numbers: ["126"] },
  //     //data: JSON.stringify({"Numbers": "['126']"}),
  //     // JSON.stringify(["Number", "contains", searchQuery]);
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //       Authorization: `Bearer ${useAuthAppStore().token}`,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }

  // async getFindStagesByPurchaseRequestNumbers({
  //   procurementServiceClient,
  //   params,
  // }) {
  //   var response = await procurementServiceClient.get({
  //     route: "/approval-matrix-step/find-by-purchase-request-numbers",
  //     params: params,
  //     //data: { Numbers: ["126"] },
  //     //data: JSON.stringify({"Numbers": "['126']"}),
  //     // JSON.stringify(["Number", "contains", searchQuery]);
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //       Authorization: `Bearer ${useAuthAppStore().token}`,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {
  //       console.log("resp", resp);
  //     },
  //   });

  //   return response;
  // }

  // async getFindByPurchaseOrderNumber({ procurementServiceClient, params }) {
  //   var response = await procurementServiceClient.get({
  //     route: "/approval-matrix-step/find-by-purchase-request-number",
  //     params: params,
  //     //data: { Numbers: ["126"] },
  //     //data: JSON.stringify({"Numbers": "['126']"}),
  //     // JSON.stringify(["Number", "contains", searchQuery]);
  //     headers: {
  //       "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
  //       Authorization: `Bearer ${useAuthAppStore().token}`,
  //     },
  //     successCallback: function (resp) {
  //       // if (resp.data.length > 0)
  //       //     _selectedJob.unitsOnTruck = resp.data;
  //     },
  //     errorCallback: function (resp) {},
  //   });

  //   return response;
  // }

}
